/* Ability Warehouse — live search dropdown under the header search box */
(function () {
  'use strict';
  var input = document.getElementById('HeaderSearch');
  if (!input || !window.CWIndex) return;
  var X = window.CWIndex;
  var cfg = window.CW || {};
  var form = input.closest('form');
  var panel = document.createElement('div');
  panel.className = 'suggest';
  panel.id = 'SearchSuggest';
  panel.setAttribute('role', 'listbox');
  panel.hidden = true;
  form.appendChild(panel);
  form.classList.add('has-suggest');
  form.style.overflow = 'visible';
  var sbtn = form.querySelector('.search__btn');
  if (sbtn) sbtn.style.borderRadius = '0 3px 3px 0';
  input.setAttribute('aria-controls', 'SearchSuggest');
  input.setAttribute('aria-expanded', 'false');
  input.setAttribute('aria-autocomplete', 'list');
  if (window.matchMedia('(max-width: 989px)').matches) input.placeholder = 'Search products, needs, brands…';

  /* Mobile & tablet: search hides behind an icon and slides open over the logo */
  var mq = window.matchMedia('(max-width: 989px)');
  var actions = document.querySelector('.header__actions');
  var toggle = null;
  if (actions) {
    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'icon-btn header__search-toggle';
    toggle.setAttribute('aria-label', 'Search products');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<svg class="icon ic-search" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>' +
      '<svg class="icon ic-close" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    actions.insertBefore(toggle, actions.firstChild);
  }
  var root = document.documentElement, closing;
  function isOpen() { return root.classList.contains('search-open'); }
  function openSearch() {
    clearTimeout(closing);
    root.classList.remove('search-closing');
    root.classList.add('search-open');
    if (toggle) { toggle.setAttribute('aria-expanded', 'true'); toggle.setAttribute('aria-label', 'Close search'); }
    setTimeout(function () { input.focus(); }, 30);
  }
  function closeSearch() {
    if (!isOpen()) return;
    show(false);
    input.blur();
    root.classList.add('search-closing');
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', 'Search products'); }
    closing = setTimeout(function () { root.classList.remove('search-open', 'search-closing'); }, 240);
  }
  if (toggle) toggle.addEventListener('click', function (e) { e.stopPropagation(); if (isOpen() && !root.classList.contains('search-closing')) closeSearch(); else openSearch(); });
  document.addEventListener('click', function (e) {
    if (mq.matches && isOpen() && !form.contains(e.target) && !(toggle && toggle.contains(e.target))) closeSearch();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mq.matches) closeSearch(); });
  mq.addEventListener && mq.addEventListener('change', function () { if (!mq.matches) root.classList.remove('search-open', 'search-closing'); });

  var items = null, loading = null, timer, active = -1;
  function ensure() {
    if (!loading) loading = X.load('/collections/all').then(function (l) { items = l; return l; });
    return loading;
  }
  function place() {
    if (!mq.matches) { panel.style.top = ''; panel.style.maxHeight = ''; return; }
    var b = (form.closest('.header') || form).getBoundingClientRect().bottom;
    panel.style.top = (b + 4) + 'px';
    panel.style.maxHeight = (window.innerHeight - b - 16) + 'px';
  }
  window.addEventListener('scroll', function () { if (!panel.hidden) place(); }, { passive: true });
  function show(on) { panel.hidden = !on; if (on) place(); input.setAttribute('aria-expanded', on ? 'true' : 'false'); form.classList.toggle('is-open', on); if (!on) active = -1; }
  function allURL(q) { return '/search?type=product&q=' + encodeURIComponent(q); }
  var FIND = cfg.finder || '/pages/product-finder';
  var findIc = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2.2"/><path d="M15.5 15.5 20 20" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/><path d="M10.5 7.2l.9 2.1 2.2.3-1.6 1.5.4 2.2-1.9-1.1-1.9 1.1.4-2.2-1.6-1.5 2.2-.3z" fill="currentColor"/></svg>';
  function findCard(q, text, strong) {
    return '<a class="suggest__find' + (strong ? ' is-strong' : '') + '" role="option" href="' + FIND + (q ? '?ask=' + encodeURIComponent(q) : '') + '">' +
      '<span class="suggest__find-ic">' + findIc + '</span><span class="suggest__find-txt"><b>Find your product</b><small>' + text + '</small></span><span class="suggest__find-go" aria-hidden="true">→</span></a>';
  }
  var POPULAR = ['Shower chair', 'Toilet frame', 'Rollator', 'Grab rail', 'Incontinence pads', 'Knee brace'];
  function starter() {
    panel.innerHTML = findCard('', 'Not sure what to search? Answer a few quick questions and we\'ll shortlist products for the need.', true) +
      '<p class="suggest__head">Popular searches</p><div class="suggest__cats">' +
      POPULAR.map(function (p) { return '<a class="suggest__cat" role="option" href="' + allURL(p) + '">' + X.esc(p) + '</a>'; }).join('') + '</div>';
    active = -1;
    show(true);
  }

  function render() {
    var q = input.value.trim();
    if (q.length < 2) { if (document.activeElement === input) starter(); else show(false); return; }
    if (!items) {
      panel.innerHTML = '<p class="suggest__msg">Searching products…</p>'; show(true);
      ensure().then(render).catch(function () { panel.innerHTML = '<a class="suggest__all" href="' + allURL(q) + '">Search for “' + X.esc(q) + '” →</a>'; });
      return;
    }
    var res = X.search(items, q);
    res = res.filter(function (i) { return i.a; }).concat(res.filter(function (i) { return !i.a; }));
    var toks = X.tokens(q);
    var cats = (cfg.links || []).filter(function (l) {
      var lt = l.l.toLowerCase();
      return toks.some(function (t) { return t.length > 2 && lt.indexOf(t) > -1; });
    }).slice(0, 4);
    var html = '';
    if (cats.length) {
      html += '<div class="suggest__cats">' + cats.map(function (c) { return '<a class="suggest__cat" role="option" href="' + c.u + '">' + X.esc(c.l) + '</a>'; }).join('') + '</div>';
    }
    if (res.length) {
      html += '<p class="suggest__head">Products <span>' + res.length + ' match' + (res.length === 1 ? '' : 'es') + '</span></p><ul class="suggest__list">';
      res.slice(0, 6).forEach(function (it) {
        var spec = [it.br, it.wr, it.wd].filter(Boolean).join(' · ');
        var unit = it.ul || '';
        html += '<li><a class="suggest__item" role="option" href="' + it.url + '">' +
          (it.im ? '<img src="' + X.img(it.im, 120) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="suggest__ph"></span>') +
          '<span class="suggest__txt"><span class="suggest__title">' + X.esc(it.t) + '</span><span class="suggest__spec">' + X.esc(spec) + (it.a ? '' : ' · <em>Sold out</em>') + '</span></span>' +
          '<span class="suggest__price">' + X.money(it.per) + '<small>' + unit + '</small>' + (it.r > it.p ? '<s>' + X.money(it.r) + '</s>' : '') + '</span></a></li>';
      });
      html += '</ul><a class="suggest__all" role="option" href="' + allURL(q) + '">See all ' + res.length + ' results for “' + X.esc(q) + '” →</a>';
      html += findCard(q, 'Narrow “' + X.esc(q) + '” down by where, what\'s hard and budget.', false);
    } else {
      html += '<p class="suggest__msg">No products match “' + X.esc(q) + '”. Try a product type, need or brand — e.g. <em>shower chair</em>, <em>toilet</em>, <em>Aidapt</em>.' +
        (cfg.phone ? ' Or call <a href="tel:' + cfg.phone.replace(/[^\d+]/g, '').replace(/^0/, '+61') + '">' + X.esc(cfg.phone) + '</a>.' : '') + '</p>';
      html += findCard(q, 'Describe the need instead — e.g. “Mum can\'t get up off the toilet” — and we\'ll find the closest products.', true);
    }
    panel.innerHTML = html;
    active = -1;
    show(true);
  }

  input.addEventListener('focus', function () { ensure(); render(); });
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(render, 90); });
  input.addEventListener('keydown', function (e) {
    var links = Array.prototype.slice.call(panel.querySelectorAll('a[role="option"]'));
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (panel.hidden || !links.length) return;
      e.preventDefault();
      active = e.key === 'ArrowDown' ? (active + 1) % links.length : (active <= 0 ? links.length - 1 : active - 1);
      links.forEach(function (l, i) { l.classList.toggle('is-active', i === active); });
      links[active].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && active > -1 && links[active]) {
      e.preventDefault(); location.href = links[active].href;
    } else if (e.key === 'Escape') { show(false); }
  });
  document.addEventListener('click', function (e) { if (!form.contains(e.target)) show(false); });
})();